'use client';

import { DateTime } from 'luxon';

import { fromTimeZoneCookie, TIMEZONE_COOKIE_NAME, toTimeZoneCookie } from '.';

import type { TimeZoneCookie } from '.';

export const setClientTimeZoneCookie = () => {
  const localTime = DateTime.local();

  const timeZoneCookie = toTimeZoneCookie({
    iana: localTime.zoneName,
    offset: localTime.offset,
  });

  document.cookie = `${TIMEZONE_COOKIE_NAME}=${timeZoneCookie}; path=/; max-age=${
    60 * 60 * 24 * 365
  }`;
};

export const getClientTimeZoneFromBrowser = (): TimeZoneCookie => {
  const localTime = DateTime.local();

  return {
    iana: localTime.zoneName,
    offset: localTime.offset,
  };
};

export const getClientTimeZoneFromCookie = (): TimeZoneCookie | undefined => {
  if (!document) {
    throw new Error('Can only be called on client side');
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|; )${TIMEZONE_COOKIE_NAME}=([^;]*)`),
  );

  if (!match) {
    return undefined;
  }

  return fromTimeZoneCookie(match[1]);
};
